<template>
  <div>
    <el-row style="display: flex;margin-bottom: 10px;">
      <el-col :span="4" v-if="theProjectId== 0">
        <el-select v-model="form.projectId" @change="theProjectAllChange" size="small" filterable clearable
          placeholder="请选择项目">
          <el-option v-for="item in getProjectList_data.data || []" :key="item.projectId" :label="item.projectName"
            :value="item.projectId">
          </el-option>
        </el-select>
      </el-col>
      <el-col v-if="form.projectId">
        <el-button v-if="addCircleBulletinItem" @click="$form('addCircleBulletinItem')" size='small' type="primary"
          style="float:right" icon='el-icon-circle-plus'>添加喜报维度
        </el-button>
      </el-col>
    </el-row>
    <div>
      <myform :viewobj='{
            addCircleBulletinItem:    [ "新增喜报维度", "el-icon-circle-plus" ],
            updateCircleBulletinItem: [ "修改喜报维度", "el-icon-edit-outline"],
            $succeed$: getCircleBulletinItemList
          }' @confirm='myform' @close='$form("addCircleBulletinItem","reset")'>
        <hide slot='projectId' />
        <hide slot='ycbiId' />
        <template v-slot:ycbaIds="{Myformdata}">
          <el-select v-model='Myformdata.ycbaIds' clearable multiple>
            <el-option v-for="item in getCircleBulletinAllList_data.data||[]" :key="item.ycbaId" :label="item.ycbaName"
              :value="item.ycbaId">
            </el-option>
          </el-select>
        </template>
      

    </myform>
    <mytable :tableColums='tableColums_getCircleBulletinItemList' api='getCircleBulletinItemList'
      xupdateapi='updateOpportunityBusinessCheckImage' :height="H-165">
    </mytable>
  </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        theProjectId: 0,
        value: '',
        form: {
          projectId: '',

        },
        tableColums_getCircleBulletinItemList: {
          $selection: false,

          // oiType: '限制字段key',

          ycbaName: '维度名称',
          ycbiOrder:'排序',

          $operation: [
            '操作', 200,
            this.updateCircleBulletinItem && `@text: 编辑#success
             @click: $form("updateCircleBulletinItem",$this.row = $row)
            `,
            this.deleteCircleBulletinItem && `@text: 删除#danger
             @click: _confirm('确定要删除该填写项约束吗?')
                     .trigger('deleteCircleBulletinItem',{ycbiId:$row.ycbiId})
                     .trigger('getCircleBulletinItemList',{projectId:form.projectId})
            `,
          ],
        }
      }
    },
    methods: {
      myform(submit, Myformdata) {
        Myformdata.projectId = this.form.projectId;
        submit();
      },
      theProjectAllChange(e) {
        if (e == '') {
          return this.form.projectId = e;
        }
        this.form.projectId = e;
        this.getCircleBulletinItemList({
          projectId: this.form.projectId
        })
      },
    },
    created() {
      this.getProjectList({
        pageSize: 0
      });

      this.theProjectId = A.local("$projectId");
      if (this.theProjectId != 0) {
        this.form.projectId = this.theProjectId;
      }
      this.getCircleBulletinItemList({
        projectId: this.form.projectId
      })
      this.getCircleBulletinAllList({
        projectId: this.form.projectId
      })
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/bussiness/goodNews.vue